<template>
  <div class="mb-4">
    <div class="form-group">
      <MappedColumnMapping v-for="(input, index) in mappings" :input="input" :key="index" @removeMapping="removeMapping" />
      <div class="row px-3">
        <div class="bg-light border d-flex align-items-center justify-content-center rounded col small text-muted">Add new mapping</div>
        <button type="button" class="btn btn-sm btn-primary ml-2 col-1" @click.prevent="addMapping"><i class="fas fa-plus"></i></button>
      </div>

    </div>
    <input type="hidden" :name="fieldName" :value="fieldValue" />
  </div>
</template>

<script>
  import MappedColumnMapping from "./MappedColumnMapping"

  export default {
    components: {MappedColumnMapping},
    props: {
      fieldName: {
        type: String,
        required: true
      },
      currentMappings: {
        type: Array,
        required: true
      }
    },
    data(){
      return {
        mappings: [ ...this.currentMappings ]
      }
    },
    computed: {
      fieldValue(){
        return JSON.stringify(this.mappings)
      }
    },
    methods: {
      addMapping(){
        this.mappings.push({from: '', to: ''})
      },
      removeMapping(input){
        this.$delete(this.mappings, this.mappings.indexOf(input))
      }
    }
  }
</script>